import { PageLoadAnalyticsMap } from "@abbvie-epi/common/models";

// empty or missing values are replaced by dynamic or fallback values
export const pageLoadAnalytics: PageLoadAnalyticsMap = {
    homepage: {
        pageInfo: {
            pageName: "Homepage",
            title: "",
            path: "/home"
        },
        category: {
            primaryCategory: "homepage"
        },
        attributes: {
            type: "Homepage"
        },
        journey: {
            content: "Homepage"
        }
    },
    "what-is-epi": {
        pageInfo: {
            pageName: "What is EPI",
            title: "",
            path: "/what-is-epi"
        },
        category: {
            primaryCategory: "what is epi"
        },
        attributes: {
            type: "Resources"
        },
        journey: {
            content: "Educate"
        }
    },
    "developing-the-tool": {
        pageInfo: {
            pageName: "Development: Developing the screening tool",
            title: "",
            path: "/development#developing-the-tool"
        },
        category: {
            primaryCategory: "development",
            subCategory1: "Developing the screening tool"
        },
        attributes: {
            type: "Resources"
        },
        journey: {
            content: "Educate"
        }
    },
    "considerations-limitations": {
        pageInfo: {
            pageName: "Development: Considerations & limitations",
            title: "",
            path: "/development#considerations-limitations"
        },
        category: {
            primaryCategory: "development",
            subCategory1: "Considerations & limitations"
        },
        attributes: {
            type: "Resources"
        },
        journey: {
            content: "Educate"
        }
    },
    "collaborators-publications": {
        pageInfo: {
            pageName: "Development: Collaborators & publications",
            title: "",
            path: "/development#collaborators-publications"
        },
        category: {
            primaryCategory: "development",
            subCategory1: "Collaborators & publications"
        },
        attributes: {
            type: "Resources"
        },
        journey: {
            content: "Educate"
        }
    },
    introduction: {
        pageInfo: {
            pageName: "The screening tool: Introduction",
            title: "",
            path: "/screening-tool-landing#introduction"
        },
        category: {
            primaryCategory: "screening tool",
            subCategory1: "Introduction"
        },
        attributes: {
            type: "Resources"
        },
        journey: {
            content: "Other"
        }
    },
    "start-screening": {
        pageInfo: {
            pageName: "The screening tool: Start Screening",
            title: "",
            path: "/screening-tool-landing#start-screening"
        },
        category: {
            primaryCategory: "screening tool",
            subCategory1: "Start Screening"
        },
        attributes: {
            type: "Resources"
        },
        journey: {
            content: "Other"
        }
    },
    "screening-result": {
        pageInfo: {
            pageName: "The screening tool: Result",
            title: "",
            path: "/screening-tool-landing#start-screening"
        },
        category: {
            primaryCategory: "screening tool",
            subCategory1: "Result"
        },
        attributes: {
            type: "Resources"
        },
        journey: {
            content: "Other"
        }
    },
    feedback: {
        pageInfo: {
            pageName: "The screening tool: Feedback",
            title: "",
            path: ""
        },
        category: {
            primaryCategory: "screening tool",
            subCategory1: "Feedback"
        },
        attributes: {
            type: "Resources"
        },
        journey: {
            content: "Other"
        }
    },
    "screening-tool": {
        pageInfo: {
            pageName: "The screening tool",
            title: "",
            path: ""
        },
        category: {
            primaryCategory: "screening tool"
        },
        attributes: {
            type: "Resources"
        },
        journey: {
            content: "Other"
        }
    },
    faqs: {
        pageInfo: {
            pageName: "Faqs",
            title: "",
            path: ""
        },
        category: {
            primaryCategory: "faqs"
        },
        attributes: {
            type: "Resources"
        },
        journey: {
            content: "Other"
        }
    },
    "page-not-found": {
        pageInfo: {
            pageName: "Page Not Found",
            title: "",
            path: ""
        },
        category: {
            primaryCategory: "Error"
        },
        attributes: {
            type: "Error Page"
        },
        journey: {
            content: "Other"
        }
    }
};
